import _get from 'lodash/get';
import { Pixall, Google } from '../analytics/index.js';
const sendClickEvent = cmp => async function (_temp, option) {
  let {
    data = {},
    event,
    dataLayer = {}
  } = _temp === void 0 ? {} : _temp;
  const {
    pixallData = {}
  } = data;
  let eventResult;
  let eventNonInteractive;
  if (cmp === 'ggl_snd_devc') {
    eventResult = 'voice-misc::send-to-device';
    eventNonInteractive = true;
  }
  if (cmp === 'amzn_enab_skl') {
    eventResult = 'voice-misc::enable-skill';
    eventNonInteractive = false;
  }
  Google.sendClickEvent({
    eventElement: 'voice-misc',
    eventResult,
    eventNonInteractive
  }, option);
  Pixall.sendClickEvent({
    ...pixallData,
    label: cmp,
    pageId: _get(dataLayer, 'page.brandPg') || _get(dataLayer, 'page.pg', '')
  }, dataLayer, option);
  return {
    cmp
  };
};

/**
 * @summary Sends Adobe/Google event when Amazon Alexa button is clicked
 * @cmp amzn_enab_skl
 * @events event1
 */
export const amazonAlexaClick = sendClickEvent('amzn_enab_skl');

/**
 * @summary Sends Adobe/Google event when Google Assistant button is clicked
 * @cmp ggl_snd_devc
 * @events event1
 */
export const googleAssistantClick = sendClickEvent('ggl_snd_devc');
export default {
  googleAssistantClick,
  amazonAlexaClick
};